import {ApiRepeatCondition} from './ApiRepeatCondition';

export class ReadApiCall {
cnxCode: string;
connectTimeout: number | null;
exitStatusOnFailure: boolean | null;
exitStatusOnSuccess: boolean | null;
logSaveFile: boolean | null;
mockFileName: string;
readTimeout: number | null;
repeatUntilCondition: ApiRepeatCondition;
saveFileName: string;
saveFilePath: string;
saveSentBody: boolean;
waitTimeBeforeRepeat: number;
}

